import { jsxs, jsx } from 'react/jsx-runtime';
import { twJoin } from 'tailwind-merge';
import 'react';
import SystemIcon from '../../DataDisplays/SystemIcon/SystemIcon.js';
import Typography from '../../Base/Typography/Typography.js';
import '../../Base/Layouts/Box/Box.js';
import '../../Base/Layouts/FullBleed/FullBleed.js';
import TextFieldContainer from '../TextFieldContainer/TextFieldContainer.js';

const SelectBox = ({ placeholder, value = '', isListOpen, disabled = false, error, onClick, className })=>{
    const generateSelectBoxTextStyles = ()=>{
        if (disabled && value) return 'text-w-gray-300';
        if (disabled && !value) return 'text-w-gray-200';
        return value ? 'text-w-gray-600' : 'text-w-gray-300';
    };
    return /*#__PURE__*/ jsxs(TextFieldContainer, {
        isDisabled: disabled,
        isFocused: isListOpen,
        isError: error,
        testId: "design-system--selectBox",
        onClick: onClick,
        className: className,
        children: [
            /*#__PURE__*/ jsx(Typography, {
                "data-testid": "design-system--selectBox-text",
                variant: "body1",
                className: twJoin(generateSelectBoxTextStyles(), 'w-full'),
                children: value ? value : placeholder
            }),
            /*#__PURE__*/ jsx("div", {
                className: twJoin('transition-transform duration-300', isListOpen && 'rotate-180'),
                children: /*#__PURE__*/ jsx(SystemIcon, {
                    name: "medium_arrow_down",
                    className: disabled ? 'text-w-gray-300' : 'text-w-gray-600',
                    testId: "design-system--selectBox-icon"
                })
            })
        ]
    });
};

export { SelectBox };
